<svg *ngIf="!img" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink" width="40" height="40" viewBox="0 0 500 500">
  <circle cx="255" cy="255" r="230" />
  <text x="255" y="246" dy="0.4em" text-anchor="middle" fill="#fff" style="dominant-baseline:auto" font-size="180"
    font-weight="700" font-family="mapfre-text">
    {{getAlias(name)}}</text>
</svg>
<img *ngIf="img" [src]="img" width=40 height=40 class="profile-pic" />
<span *ngIf="title">{{name}}</span>
